/* BF2026 October Flash Deal landing pages (tea + coffee). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('.bf26[data-bf-deal]');
  if (!root) return;
  var deal = root.getAttribute('data-bf-deal');
  var shopRoot = root.getAttribute('data-root') || '/';
  if (shopRoot.slice(-1) !== '/') shopRoot += '/';

  function $all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function hooks(name) { return $all('[data-bf="' + name + '"]'); }
  function setText(name, txt) { hooks(name).forEach(function (el) { el.textContent = txt; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function track(name, params) {
    try { if (window.gtag) window.gtag('event', name, params || {}); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', name, params || {}); } catch (e) {}
  }

  /* ---------- reliable scroll (theme sets html{scroll-behavior:smooth}, which can stall) ---------- */
  function goTo(el, block) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset;
    var y = block === 'start' ? top - 16 : top - Math.max(16, (window.innerHeight - el.offsetHeight) / 2);
    y = Math.max(0, Math.round(y));
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    setTimeout(function () {
      var r = el.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        var h = document.documentElement, old = h.style.scrollBehavior;
        h.style.scrollBehavior = 'auto'; window.scrollTo(0, y); h.style.scrollBehavior = old;
      }
    }, 750);
  }
  function pulse(el) {
    if (!el) return;
    el.classList.remove('bf-pulse'); void el.offsetWidth; el.classList.add('bf-pulse');
    setTimeout(function () { el.classList.remove('bf-pulse'); }, 2000);
  }
  function goTray() { var box = root.querySelector('.a-box'); goTo(box, 'center'); setTimeout(function () { pulse(box); }, 350); }

  /* ---------- countdown: to the next Wednesday or Sunday 23:59:59, Riga time ---------- */
  var TZ = 'Europe/Riga';
  function rigaParts(t) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', weekday: 'short' });
    var o = {}; f.formatToParts(new Date(t)).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, mi: +o.minute, s: +o.second, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday) };
  }
  function rigaToUtc(y, m, d, h, mi, s) {
    var guess = Date.UTC(y, m - 1, d, h, mi, s) - 2 * 3600000;
    for (var i = 0; i < 2; i++) {
      var p = rigaParts(guess);
      var asUtc = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s);
      guess += Date.UTC(y, m - 1, d, h, mi, s) - asUtc;
    }
    return guess;
  }
  function nextDeadline(now) {
    var p = rigaParts(now);
    for (var i = 0; i < 8; i++) {
      var wd = (p.wd + i) % 7;
      if (wd !== 0 && wd !== 3) continue;
      var dt = new Date(Date.UTC(p.y, p.m - 1, p.d + i));
      var t = rigaToUtc(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate(), 23, 59, 59);
      if (t > now) return t;
    }
    return now + 86400000;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var end = 0;
  function tick() {
    var now = Date.now();
    if (!end || now >= end) { try { end = nextDeadline(now); } catch (e) { end = now + 86400000; } }
    var ms = Math.max(0, end - now);
    var d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
    setText('cd', pad(d) + 'd ' + pad(h) + 'h ' + pad(m) + 'm');
  }
  tick(); setInterval(tick, 30000);

  /* ---------- cart ---------- */
  function addToCart(items) {
    return fetch(shopRoot + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not add to cart'); e.data = j; throw e; } return j; });
    });
  }
  function openCart() {
    var drawer = document.querySelector('m-cart-drawer');
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        fetch(shopRoot + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, cart, { source: 'bf26' }));
        }).catch(function () {});
      }
    } catch (e) {}
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function' && typeof drawer.open === 'function') {
      drawer.onCartDrawerUpdate();
      setTimeout(function () { drawer.open(); }, 350);
    } else {
      window.location.href = shopRoot + 'cart';
    }
  }
  function setMsg(t) { setText('msg', t || ''); }

  /* =========================================================== TEA */
  function initTea() {
    var tiles = $all('.tile[data-tea]');
    var INFO = {
      emperor: ['Black and green tea', 'Peach, rosehip, tropical fruit'], cookies: ['Black tea', 'Orange, cinnamon, cardamom'],
      kiss: ['Green and white tea', 'Passionfruit and strawberry'], oolong: ['Oolong', 'Creamy, like condensed milk'],
      bush: ['Rooibos', 'Sweet orange'], sin: ['Rooibos', 'Raspberry and vanilla'], garden: ['Fruit tea', 'Strawberry, blackberry, rhubarb'],
      cloud: ['Fruit tea', 'Kiwi, sour cherry, coconut'], grapefruit: ['Herbal tea', 'Orange, grapefruit, eucalyptus'], shui: ['Herbal tea', 'Strawberry and bergamot']
    };
    $all('.mcard').forEach(function (c) {
      if (!c.querySelector('.mcap')) { var p = document.createElement('p'); p.className = 'mcap'; p.innerHTML = '<b></b><span class="ty"></span><span class="ta"></span>'; c.appendChild(p); }
    });
    hooks('hand').forEach(function (el) { el.remove(); });
    if (!hooks('handnames').length) { var hn = document.createElement('p'); hn.className = 'sr-only'; hn.setAttribute('aria-live', 'polite'); hn.setAttribute('data-bf', 'handnames'); var dk = hooks('deck')[0]; if (dk) dk.parentNode.insertBefore(hn, dk.nextSibling); }
    var TEAS = tiles.map(function (el) {
      return {
        id: el.getAttribute('data-tea'), el: el, name: el.getAttribute('data-name'), img: el.getAttribute('data-img'),
        caf: el.getAttribute('data-caf') === '1', type: el.getAttribute('data-type') || (INFO[el.getAttribute('data-tea')] || [])[0] || '', taste: el.getAttribute('data-taste') || (INFO[el.getAttribute('data-tea')] || [])[1] || '', variant: +el.getAttribute('data-variant'),
        avail: el.getAttribute('data-avail') === '1', max: +el.getAttribute('data-max') || 0
      };
    });
    var byId = {}; TEAS.forEach(function (t) { byId[t.id] = t; });
    var S = { qty: {}, filter: 'all', added: false, busy: false, deal: null, flipped: false, shuffling: false, dealTaken: false };

    function total() { return Object.keys(S.qty).reduce(function (n, k) { return n + S.qty[k]; }, 0); }
    function canAdd(id) { var t = byId[id]; return t && t.avail && (S.qty[id] || 0) < t.max && total() < 5; }
    function plus(id) { if (!canAdd(id)) return; S.qty[id] = (S.qty[id] || 0) + 1; S.added = false; S.dealTaken = false; render(); }
    function minus(id) { if (!S.qty[id]) return; S.qty[id]--; if (!S.qty[id]) delete S.qty[id]; S.added = false; S.dealTaken = false; render(); }
    function setFive(ids) {
      var q = {};
      for (var i = 0; i < ids.length; i++) { var t = byId[ids[i]]; if (!t || !t.avail || (q[t.id] || 0) >= t.max) return false; q[t.id] = (q[t.id] || 0) + 1; }
      S.qty = q; S.added = false; render(); return true;
    }
    function availIds() { return TEAS.filter(function (t) { return t.avail && t.max > 0; }).map(function (t) { return t.id; }); }

    var STEP_MINUS = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M3 9h12"/></svg>';
    var STEP_PLUS = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M9 3v12M3 9h12"/></svg>';
    var ADD_PLUS = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M9 3v12M3 9h12"/></svg>';

    function render() {
      var n = total(), full = n >= 5;
      setText('total', String(n));
      // tray
      var picked = []; TEAS.forEach(function (t) { for (var i = 0; i < (S.qty[t.id] || 0); i++) picked.push(t); });
      var sh = '';
      for (var i = 0; i < 5; i++) {
        var t = picked[i];
        sh += t ? '<button type="button" class="slot full" data-minus="' + t.id + '" aria-label="Remove ' + esc(t.name) + '"><img src="' + esc(t.img) + '" alt=""><span class="x" aria-hidden="true">×</span></button>'
          : '<span class="slot" aria-hidden="true">' + (i + 1) + '</span>';
      }
      hooks('slots').forEach(function (el) { el.innerHTML = sh; });
      // rail
      hooks('rail').forEach(function (el) { $all('.seg', el).forEach(function (s, i) { s.className = i < n ? 'seg on' : 'seg'; }); });
      var note = n === 5 ? '€10 off applied' : (n === 0 ? 'Fill all 5 slots to get your €10 discount' : (n === 4 ? 'Add 1 more and your total drops from €31.80 to €29.75' : (5 - n) + ' more and your total drops to €29.75'));
      if (S.added) note = 'In your cart, €10 off applied';
      setText('railnote', note);
      // tiles
      TEAS.forEach(function (t) {
        var q = S.qty[t.id] || 0, el = t.el;
        var show = S.filter === 'all' || (S.filter === 'free' && !t.caf) || (S.filter === 'caf' && t.caf);
        el.hidden = !show;
        el.classList.toggle('on', q > 0);
        var qb = el.querySelector('.qb'); qb.hidden = q === 0; qb.textContent = q;
        var ctl = el.querySelector('.ctl'), plusOff = !canAdd(t.id);
        if (!t.avail) { ctl.innerHTML = ''; return; }
        ctl.innerHTML = q === 0
          ? '<button type="button" class="btn btn-line btn-block btn-sm a-add" data-plus="' + t.id + '"' + (plusOff ? ' disabled' : '') + ' aria-label="Add ' + esc(t.name) + '">' + ADD_PLUS + 'Add</button>'
          : '<div class="stepper"><button type="button" data-minus="' + t.id + '" aria-label="Remove one ' + esc(t.name) + '">' + STEP_MINUS + '</button><output>' + q + '</output><button type="button" data-plus="' + t.id + '"' + (plusOff ? ' disabled' : '') + ' aria-label="Add one more ' + esc(t.name) + '">' + STEP_PLUS + '</button></div>';
      });
      $all('[data-filter]').forEach(function (b) { var on = b.getAttribute('data-filter') === S.filter; b.className = on ? 'chip on' : 'chip'; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      // sets availability
      $all('[data-set]').forEach(function (b) {
        var ids = b.getAttribute('data-set').split(',');
        b.disabled = !ids.every(function (id) { return byId[id] && byId[id].avail && byId[id].max >= 1; });
      });
      // deck
      var deck = hooks('deck')[0];
      if (deck) {
        deck.className = 'deck' + (S.shuffling ? ' shuffling' : '') + (S.flipped && S.deal ? ' dealt' : '');
        $all('.mcard', deck).forEach(function (c, i) {
          var t = S.deal ? byId[S.deal[i]] : null;
          c.className = 'mcard' + (S.flipped && t ? ' flip' : '');
          var im = c.querySelector('.front img');
          if (t) { im.src = t.img; im.hidden = false; } else { im.hidden = true; }
          var cap = c.querySelector('.mcap');
          if (cap) { cap.querySelector('b').textContent = t ? t.name : ''; cap.querySelector('.ty').textContent = t ? t.type : ''; cap.querySelector('.ta').textContent = t ? t.taste : ''; }
        });
      }
      var shown = S.flipped && !!S.deal;
      setText('handnames', shown ? 'Your hand: ' + S.deal.map(function (id) { return byId[id].name + ', ' + byId[id].type; }).join('; ') : '');
      hooks('take').forEach(function (b) { b.hidden = !shown; b.disabled = S.dealTaken; b.textContent = S.dealTaken ? 'In your tray ✓' : 'Take these 5'; });
      setText('shufflelabel', S.shuffling ? 'Shuffling…' : (S.deal ? 'Shuffle again' : 'Choose 5 random boxes for me'));
      // bar + CTA
      var head = 'Pick 5, save €10', sub = '€29.75 instead of €39.75', cta = 'Choose 5 boxes';
      if (n > 0 && n < 5) { head = (5 - n) + ' more for €10 off'; sub = n + ' in your deal so far'; cta = 'Pick ' + (5 - n) + ' more'; }
      var ctaHtml = '';
      if (n === 5) { head = '€29.75'; sub = 'instead of €39.75 · €10 off'; cta = 'Add to cart'; ctaHtml = 'Add to cart · €29.75<span class="bf-save">Save €10</span>'; }
      if (S.busy) cta = 'Adding…';
      if (S.added) { head = 'In your cart'; sub = '€29.75 · €10 off applied'; cta = 'Added ✓'; }
      setText('barhead', head); setText('barsub', sub);
      hooks('cta').forEach(function (b) { if (ctaHtml && !S.busy && !S.added && !b.closest('.bar')) b.innerHTML = ctaHtml; else b.textContent = cta; b.disabled = S.added || S.busy; });
    }

    function onCta() {
      if (S.added || S.busy) return;
      if (total() < 5) { goTo(document.getElementById('pick'), 'start'); return; }
      var items = Object.keys(S.qty).map(function (id) { return { id: byId[id].variant, quantity: S.qty[id] }; });
      S.busy = true; setMsg(''); render();
      addToCart(items).then(function () {
        S.busy = false; S.added = true; render(); openCart();
        track('bf26_add_to_cart', { deal: 'tea', value: 29.75, currency: 'EUR' });
      }).catch(function (e) {
        S.busy = false; render();
        setMsg('Sorry, we could not add these boxes: ' + (e.message || 'please try again') + '.');
      });
    }

    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('button'); if (!b || !root.contains(b) || b.disabled) return;
      if (b.hasAttribute('data-plus')) return plus(b.getAttribute('data-plus'));
      if (b.hasAttribute('data-minus')) return minus(b.getAttribute('data-minus'));
      if (b.hasAttribute('data-filter')) { S.filter = b.getAttribute('data-filter'); return render(); }
      if (b.hasAttribute('data-set')) { if (setFive(b.getAttribute('data-set').split(','))) { track('bf26_take_set', { deal: 'tea' }); goTray(); } return; }
      var h = b.getAttribute('data-bf');
      if (h === 'cta') return onCta();
      if (h === 'shuffle') {
        if (S.shuffling) return;
        var pick = shuffle(availIds()).slice(0, 5); if (pick.length < 5) return;
        var wasFlipped = S.flipped;
        S.flipped = false; S.shuffling = true; S.dealTaken = false; render();
        setTimeout(function () { S.deal = pick; S.shuffling = false; S.flipped = true; render(); }, wasFlipped ? 1000 : 750);
        return;
      }
      if (h === 'take') { if (S.deal && setFive(S.deal)) { S.dealTaken = true; render(); track('bf26_take_deck', { deal: 'tea' }); goTray(); } return; }
    });
    render();
  }

  /* =========================================================== COFFEE */
  function initCoffee() {
    var variant = +root.getAttribute('data-variant');
    var avail = root.getAttribute('data-avail') === '1' && variant > 0;
    var max = Math.min(3, +root.getAttribute('data-max') || 0);
    var BOX = root.getAttribute('data-box');
    var S = { boxes: 0, added: false, busy: false, met: [], active: null };

    function set(n) { S.boxes = Math.max(0, Math.min(3, n)); S.added = false; render(); }

    function render() {
      var n = S.boxes;
      setText('total', String(n));
      var sh = '';
      for (var i = 0; i < 3; i++) {
        sh += i < n ? '<button type="button" class="slot full" data-act="remove" aria-label="Remove one box"><img src="' + esc(BOX) + '" alt=""><span class="x" aria-hidden="true">×</span></button>'
          : '<button type="button" class="slot k-add" data-act="add" aria-label="Add a box"' + (avail ? '' : ' disabled') + '><span class="k-plus" aria-hidden="true">+</span></button>';
      }
      hooks('slots').forEach(function (el) { el.innerHTML = sh; });
      var cta = 'Fill my 3 boxes', bar = 'Fill my 3 boxes', head = 'Take 3, save €10', sub = '€34.85 instead of €44.85';
      if (n > 0 && n < 3) { cta = bar = 'Add ' + (3 - n) + ' more'; head = (3 - n) + ' more for €10 off'; sub = n + ' in your deal so far'; }
      if (n === 3) { cta = 'Add to cart · €34.85'; bar = 'Add to cart'; head = '€34.85'; sub = 'instead of €44.85'; }
      if (S.busy) cta = bar = 'Adding…';
      if (S.added) { cta = 'Added to cart ✓'; bar = 'Added ✓'; head = 'In your cart'; sub = '€10 off applied'; }
      if (!avail || max < 3) { cta = bar = 'Sold out'; head = 'Sold out'; sub = 'This deal is no longer available'; }
      setText('barhead', head); setText('barsub', sub);
      hooks('cta').forEach(function (b) { if (b.closest('.bar')) b.textContent = bar; else if (n === 3 && !S.busy && !S.added && avail && max >= 3) b.innerHTML = 'Add to cart · €34.85<span class="bf-save">Save €10</span>'; else b.textContent = cta; b.disabled = S.added || S.busy || !avail || max < 3; });
      // pull a sachet
      $all('[data-origin]').forEach(function (b) {
        var id = b.getAttribute('data-origin'), up = S.active === id, met = S.met.indexOf(id) >= 0;
        b.className = 'sach pb-sach' + (up ? ' up' : '') + (met && !up ? ' met' : '') + (S.met.length === 0 ? ' hint' : '');
        b.setAttribute('aria-pressed', up ? 'true' : 'false');
        b.setAttribute('aria-label', (up ? 'Put back ' : 'Pull out ') + b.getAttribute('data-country'));
      });
      hooks('pull').forEach(function (el) { el.hidden = S.met.length > 0; });
      setText('met', 'Met ' + S.met.length + ' of 4');
      hooks('dots').forEach(function (el) {
        var ids = $all('[data-origin]').map(function (b) { return b.getAttribute('data-origin'); });
        $all('.pb-dot', el).forEach(function (d, i) { d.className = S.met.indexOf(ids[i]) >= 0 ? 'pb-dot on' : 'pb-dot'; });
      });
      var card = '';
      var act = S.active ? root.querySelector('[data-origin="' + S.active + '"]') : null;
      if (act) {
        card = '<div class="pb-card"><img class="pb-flag" src="' + esc(act.getAttribute('data-flag')) + '" alt=""><b>' + esc(act.getAttribute('data-country')) + '</b><span class="n">' + esc(act.getAttribute('data-oname')) + '</span><span class="t">' + esc(act.getAttribute('data-notes')) + '. ' + esc(act.getAttribute('data-line')) + '</span><span class="q">3 in every box · 9 in your 3-box deal</span></div>';
      } else if (S.met.length === 4) {
        card = '<div class="pb-card done"><b>You\'ve met all four.</b><span class="t">Every box has 3 of each, so your 3-box deal brings 9 of every coffee.</span></div>';
      } else {
        card = '<div class="pb-card empty">' + (S.met.length === 0 ? 'Tap a sachet to pull it out.' : 'Tap the next sachet.') + '</div>';
      }
      hooks('pbcard').forEach(function (el) { el.innerHTML = card; });
    }

    function onCta() {
      if (S.added || S.busy || !avail) return;
      if (S.boxes < 3) { set(3); return; }
      S.busy = true; setMsg(''); render();
      addToCart([{ id: variant, quantity: 3 }]).then(function () {
        S.busy = false; S.added = true; render(); openCart();
        track('bf26_add_to_cart', { deal: 'coffee', value: 34.85, currency: 'EUR' });
      }).catch(function (e) {
        S.busy = false; render();
        setMsg('Sorry, we could not add the boxes: ' + (e.message || 'please try again') + '.');
      });
    }

    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('button'); if (!b || !root.contains(b) || b.disabled) return;
      var act = b.getAttribute('data-act');
      if (act === 'add') return set(S.boxes + 1);
      if (act === 'remove') return set(S.boxes - 1);
      if (b.hasAttribute('data-origin')) {
        var id = b.getAttribute('data-origin');
        if (S.met.indexOf(id) < 0) S.met.push(id);
        S.active = S.active === id ? null : id; render(); return;
      }
      var h = b.getAttribute('data-bf');
      if (h === 'cta') return onCta();
      if (h === 'fill') { set(3); goTray(); return; }
    });
    render();
  }

  if (deal === 'tea') initTea(); else initCoffee();
})();
